module.exports = __webpack_public_path__ + "img/bank-delete-transaction.ef5e119b.svg";